/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { text } from '../artifacts/sourcecode.json';
import { useOutletContext } from "react-router-dom";
import { useState } from 'react';
import { ethers} from 'ethers'
import reBurnToken from '../artifacts/contracts/reBurnToken.sol/reBurnToken.json'

export default function Source() {
  const [web3] = useOutletContext();
    const [state, setState] = useState({
        tokenAddress: "",
        encode: "",
        isComputing: false,
    })

    function bumpState(newStateChunk) {
        setState(prev => {return {
                ...prev,
                ...newStateChunk
        }});
    }
    function handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        bumpState({[name]: value, valid: true})
    }

    async function compute(event) {
        event.preventDefault();
        if (!state.tokenAddress)
            return;

        try {
            bumpState({isComputing: true});

            const contract = new ethers.Contract(state.tokenAddress, reBurnToken.abi, web3)
            const token = await contract.token();
            const burnAddress = await contract.burnAddress();
            const treasury = await contract.treasury();
            const symbol = await contract.symbol();
            const name = await contract.name();

            const encode = ethers.utils.defaultAbiCoder.encode(reBurnToken.abi[0].inputs, [
                name,
                symbol,
                token,
                burnAddress,
                treasury
            ]);
            bumpState({encode: encode.substring(2)});
        } finally {
            bumpState({isComputing: false});
        }
    }

  return (
    <>
    <h1>Source code</h1>
    <p className="lead">
    Here is the source code for the reBurn Token.
    </p>
    <pre>
    Solidity version: 0.8.3
    Optimizer: enabled
    Runs: 20
    </pre>
    <div className="lead">
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="tokenAddress" className="form-label">Source token address</label>
            <input type="text" className="form-control" id="tokenAddress" name="tokenAddress" value={state.tokenAddress} onChange={handleChange}/>
          </div>
          <div className="col-md-12">
            {state.isComputing ?
                <button type="submit" className="btn btn-primary" disabled>Computing constructor ABI</button>
                :
                <button type="submit" className="btn btn-primary" onClick={compute}>Compute constructor ABI</button>
            }
          </div>
          <div className="col-md-12">
            <label htmlFor="abi" className="form-label">ABI encoded constructor</label>
            <textarea className="form-control" id="abi" rows="10" name="abi" value={state.encode} readOnly></textarea>
          </div>
        </form>
    </div>
    <p className="lead">
    Source code:
    <textarea className="form-control" id="sourcecode" rows="10" name="sourcecode" value={text} readOnly></textarea>
    </p>
    </>
  );
}